function simpleRandomHash(): string {
  return Math.random().toString(36).slice(-8);
}

export { simpleRandomHash };
